module.exports = __webpack_public_path__ + "img/plug.ebe82c1a.svg";